import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy, filters } from "./Column.js";
import BasicTable from "../../../components/Table/BasicTable.jsx";
import BreadCrumb from "../../../components/BreadCrumb.jsx";
import { InventoryApi } from "../../../apis/inventory.api.js";
import AddStockLedgerReport from "./AddStockLedgerReport.jsx";

const StockLedgerReport = () => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const [allLedgerReportData, setLedgerReportData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(null);

  /** Fetch stock ledger reports */
  const getAllLedgerReport = useCallback(async () => {
    try {
      const res = await InventoryApi.getAllLedgerReport(pagination, search);
      setLedgerReportData(res?.data?.data);
    } catch (error) {
      console.error("Error fetching stock ledger reports:", error);
    }
  }, [pagination, search]);

  /** Update pagination state */
  const handlePagination = (data) => {
    setPagination((prev) => ({
      ...prev,
      ...data,
      filter: data.filter ? { ...prev.filter, ...data.filter } : prev.filter,
    }));
  };

  /** Debounced search input */
  const debouncedSearch = (s) => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => setSearch(s), 500);
  };

  /** Clear filters */
  const handleClearFilter = () => {
    setPagination({ page: 1, limit: 5, sortOrder: "desc", filter: {} });
    setSearch("");
  };

  /** Handle table sorting and filters */
  const handleFilter = (name, value) => {
    handlePagination({
      filter: name === "search_by" ? { sortOrder: value.code } : { [name]: value.code || value },
    });
  };

  /** Handle table cell clicks */
  const handleCellClick = (cell, field) => {
    if (field === "itemDescription") {
      setEditRolePermissions(cell);
      setModalOpen(true);
    }
  };

  /** Close modal */
  const closeRoleModal = () => {
    setModalOpen(false);
    setEditRolePermissions(null);
  };

  useEffect(() => {
    getAllLedgerReport();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BreadCrumb title="Stock Ledger" />

      <BasicTable
        columns={columns}
        data={allLedgerReportData?.stockLedgerReport || []}
        onPaginatorClick={(e) => handlePagination({ limit: e.rows, page: e.page + 1 })}
        paginatorData={{
          first: 0,
          page: pagination.page,
          rows: pagination.limit,
          totalPages: allLedgerReportData?.totalPages || 1,
          totalCount: allLedgerReportData?.totalCount || 1,
        }}
        handleSearch={debouncedSearch}
        searchBy={searchBy}
        filters={filters}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        handleCellClick={handleCellClick}
      />

      <AddStockLedgerReport
        getAllData={getAllLedgerReport}
        currentItems={editRolePermissions}
        open={modalOpen}
        handleClose={closeRoleModal}
      />
    </div>
  );
};

export default StockLedgerReport;
